import { Image } from 'lucide-react';
import type { ImageBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const imageConfig: BlockTypeConfig<ImageBlock> = {
  type: 'image',
  label: 'Image',
  description: 'Single image with optional caption and link',
  icon: Image,
  category: 'media',
  createDefault: () => ({
    src: '',
    alt: '',
    aspectRatio: 'auto',
  }),
  toolbar: [
    { kind: 'media', path: 'data.src', label: 'Image', assetType: 'image' },
    {
      kind: 'select',
      path: 'data.width',
      label: 'Width',
      options: [
        { value: 'full', label: 'Full' },
        { value: 'wide', label: 'Wide' },
        { value: 'medium', label: 'Medium' },
        { value: 'small', label: 'Small' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  sheet: [
    { kind: 'text', path: 'data.alt', label: 'Alt text', placeholder: 'Describe the image' },
    { kind: 'text', path: 'data.caption', label: 'Caption' },
    { kind: 'link', path: 'data.linkUrl', label: 'Link URL' },
    {
      kind: 'select',
      path: 'data.aspectRatio',
      label: 'Aspect ratio',
      options: [
        { value: 'auto', label: 'Auto' },
        { value: 'video', label: '16:9' },
        { value: 'square', label: '1:1' },
        { value: '4/3', label: '4:3' },
      ],
    },
    { kind: 'toggle', path: 'data.rounded', label: 'Rounded corners' },
    { kind: 'toggle', path: 'data.shadow', label: 'Shadow' },
  ],
};
